import ConfirmPhoneNumber from './ConfirmPhoneNumber'

export default ConfirmPhoneNumber;